// extracted by mini-css-extract-plugin
export default {"startupLink":"DemandesContactClient_startupLink__zdIfX","buttonLoad":"DemandesContactClient_buttonLoad__ANdSp"};